<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click.stop="exportarPlanilha(contrato)">
            <span>
                <i class="fa fa-file-excel-o mr-2"></i> Exportar Planilha
            </span>
        </b-button>
    </div>
</template>

<script>

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },
        
        dataServicos: {
            type: Object
        }
    },

    data() {
        return {
        }
    },

    methods: {
        exportarPlanilha(contrato) {
            this.$store.dispatch('addRequest')
            this.dataServicos.exportarPlanilhaSubItens(contrato).then(
                (response) => {
                    if (response) {
                        if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                        } else {
                            this.$download(response, 'ListagemSubitens.xlsx')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },
    }
}
</script>
